(function () {
    const DEBUG = false;
    const log = (...a) => DEBUG && console.log("[GAD-APPLY]", ...a);
    const warn = (...a) => DEBUG && console.warn("[GAD-APPLY]", ...a);

    const now = () => Date.now();
    const euroToNumber = (str) => str ? parseFloat(String(str).replace(/[€\s\u00A0]/g, '').replace(',', '.')) : NaN;
    const euroInt = (n) => Math.round(n) + "€";

    /** format Shopify price (cents) to display string */
    function formatPrice(priceInCents) {
        const price = priceInCents / 100;
        // Format with comma as decimal separator (French style)
        const formatted = price.toFixed(2).replace('.', ',');
        return formatted + "€";
    }

    /** map variant titles → ids from JSON, and store variant data */
    function getVariantsMap() {
        const map = {};
        const variantData = {}; // Store full variant data by ID
        const variantIds = []; // All variant IDs for this product
        const jsonEl = document.querySelector('variant-radios script[type="application/json"]');
        if (!jsonEl) return { map, variantData, variantIds };
        try {
            JSON.parse(jsonEl.textContent).forEach(v => {
                // normalize titles (strip () content, trim)
                let t = (v.public_title || v.option1 || v.title || "").replace(/\(.*?\)/g, "").trim();
                const variantId = String(v.id);
                map[t] = variantId;
                variantIds.push(variantId);

                // Store variant data including price
                variantData[variantId] = {
                    id: variantId,
                    price: v.price,
                    title: t
                };

                log("Variant map:", t, "→", v.id, "| Price:", v.price);
            });
        } catch (e) { warn("variant JSON parse failed", e); }
        log("Complete variant map:", map);
        log("Product variant IDs:", variantIds);
        return { map, variantData, variantIds };
    }

    /** check discount eligibility */
    function validItem(item) {
        return item
            && item.path === location.pathname
            && item.expireTime > now()
            && (!item.currency || item.currency === window.MFGAD?.currency);
    }

    /** mark the currently selected variant as active */
    function markActiveVariant() {
        const blocks = document.querySelectorAll(".radio_variant_picker");
        log("=== MARKING ACTIVE VARIANT ===");
        blocks.forEach((block, index) => {
            const radio = block.querySelector("input[type=radio]");
            const title = block.querySelector(".var_title")?.textContent.trim();
            if (radio?.checked) {
                block.classList.add("active_variant");
                log(`✓ Block ${index} ACTIVE:`, title, "| Radio ID:", radio.id, "| Checked:", radio.checked);
            } else {
                block.classList.remove("active_variant");
                log(`  Block ${index}:`, title, "| Radio ID:", radio.id, "| Checked:", radio.checked);
            }
        });
    }

    /** update one block */
    function applyToBlock(block, item) {
        // price (discountPrice as-is)
        const priceEl = block.querySelector(".var_prie");
        if (priceEl && item.discountPrice) {
            priceEl.textContent = String(item.discountPrice).trim();
            log("block price set", item.discountPrice);
        }

        // eco badge (discountAmount rounded)
        const ecoEl = block.querySelector(".variant_rec");
        if (ecoEl && item.discountAmount) {
            const disc = euroToNumber(item.discountAmount);
            if (isFinite(disc)) {
                // keep "ÉCO " if it was there originally
                const prefix = ecoEl.dataset.prefix || (ecoEl.textContent.match(/^\D+/)?.[0] || "");
                ecoEl.dataset.prefix = prefix; // store it once
                ecoEl.textContent = prefix.trim() + " " + euroInt(disc);
                log("eco set", ecoEl.textContent);
            }
        }

        // per-unit
        const unitEl = block.querySelector(".price_per_unit[data-unit-count]");
        if (unitEl && item.discountPrice) {
            const cnt = parseInt(unitEl.dataset.unitCount, 10) || 1;
            const total = euroToNumber(item.discountPrice);
            if (isFinite(total) && cnt > 0) unitEl.textContent = euroInt(total / cnt);
            log("per-unit set", unitEl.textContent);
        }
    }

    /** update all blocks + widget */
    function applyAll() {
        if (!window.MFGAD || !MFGAD.savedItems) return;

        log("\n========== APPLY ALL START ==========");
        log("MFGAD.savedItems:", Object.keys(MFGAD.savedItems));

        // First, mark which variant is currently selected
        markActiveVariant();

        const { map: vMap, variantData } = getVariantsMap();
        const blocks = document.querySelectorAll(".radio_variant_picker");
        let activeItem = null;
        let activeBlock = null;
        let activeTitle = null;
        let activeVariantId = null;

        log("\n=== PROCESSING BLOCKS ===");
        blocks.forEach((block, index) => {
            const title = (block.querySelector(".var_title")?.textContent || "").replace(/\(.*?\)/g, "").trim();
            const variantId = vMap[title];
            const item = MFGAD.savedItems[variantId];
            const isActive = block.classList.contains("active_variant");

            log(`Block ${index}: "${title}"`);
            log(`  → Variant ID: ${variantId}`);
            log(`  → Has discount: ${!!item}`, item ? `(${item.discountPrice})` : "");
            log(`  → Is active: ${isActive}`);
            log(`  → Valid: ${validItem(item)}`);

            // Track active block FIRST, before any early returns
            if (isActive) {
                activeItem = item; // might be null for non-discounted variants
                activeBlock = block;
                activeTitle = title;
                activeVariantId = variantId;
                log(`  ★ THIS IS THE ACTIVE BLOCK ★`);
            }

            // Only apply discounts if item is valid
            if (!validItem(item)) return;
            applyToBlock(block, item);
        });

        log("\n=== ACTIVE VARIANT SUMMARY ===");
        log("Active title:", activeTitle);
        log("Active variant ID:", activeVariantId);
        log("Active has discount:", !!activeItem);
        log("Active discount price:", activeItem?.discountPrice);
        log("Active block price element:", activeBlock?.querySelector(".var_prie")?.textContent);

        // Update widget based on active variant
        log("\n=== WIDGET UPDATE ===");
        if (activeItem?.discountPrice) {
            // Active variant has MFGAD discount - use discount price
            waitForWidget(el => {
                const currentWidgetPrice = el.textContent;
                log("Current widget price:", currentWidgetPrice);
                el.textContent = activeItem.discountPrice;
                log("→ Setting widget to DISCOUNT:", activeItem.discountPrice);
                log("New widget price:", el.textContent);
            });
        } else if (activeVariantId && variantData[activeVariantId]) {
            // Active variant has no discount - use original Shopify price from JSON
            const variant = variantData[activeVariantId];
            const originalPrice = formatPrice(variant.price);

            waitForWidget(el => {
                const currentWidgetPrice = el.textContent;
                log("Current widget price:", currentWidgetPrice);
                log("Variant price from JSON:", variant.price, "cents");
                el.textContent = originalPrice;
                log("→ Setting widget to ORIGINAL price:", originalPrice);
                log("New widget price:", el.textContent);
            });
        } else {
            log("→ No active variant found - widget unchanged");
        }
        log("========== APPLY ALL END ==========\n");
    }

    /** wait for late widget */
    function waitForWidget(cb) {
        const sel = ".rc_widget__price--onetime, .rc-option__price";
        let tries = 0;
        const t = setInterval(() => {
            const el = document.querySelector(sel);
            if (el) {
                clearInterval(t);
                cb(el);
            } else if (++tries > 100) {
                clearInterval(t);
                warn("widget not found after 10s");
            }
        }, 100);
    }

    /** wait for MFGAD hydration with data for THIS product */
    function waitForDiscounts(productVariantIds, done) {
        const start = now();
        const tick = () => {
            // Check if MFGAD has loaded discount data for ANY variant of this product
            if (MFGAD?.savedItems) {
                const savedIds = Object.keys(MFGAD.savedItems);
                const hasMatchingVariant = savedIds.some(id => productVariantIds.includes(id));

                if (hasMatchingVariant) {
                    log("savedItems ready with matching variants:", savedIds.filter(id => productVariantIds.includes(id)));
                    done();
                    return;
                }

                log("Waiting... savedItems has:", savedIds, "but product needs:", productVariantIds);
            }

            // Timeout after 10 seconds - run anyway (product might have no discount)
            if (now() - start > 10000) {
                warn("timeout waiting for matching variant discount - running anyway");
                done();
                return;
            }
            setTimeout(tick, 150);
        };
        tick();
    }

    /** bind reapply events */
    function wireReapply() {
        const root = document.querySelector("variant-radios, fieldset.js.product-form__input") || document;
        root.addEventListener("change", e => {
            if (e.target.matches("input[type=radio]")) {
                setTimeout(applyAll, 50);
            }
        });

        // Optimized observer: only watch for radio input changes, with debouncing
        const container = document.querySelector("variant-radios") || document.body;
        let debounceTimer;
        new MutationObserver((mutations) => {
            // Only react to checked attribute changes on radio inputs
            const hasRadioChange = mutations.some(m =>
                m.type === 'attributes' &&
                m.attributeName === 'checked' &&
                m.target.matches('input[type=radio]')
            );

            if (hasRadioChange) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(applyAll, 50);
            }
        }).observe(container, {
            subtree: true,
            attributes: true,
            attributeFilter: ['checked']
        });
    }

    function init() {
        log("init");

        // Get product variant IDs first
        const { variantIds } = getVariantsMap();

        if (!variantIds || variantIds.length === 0) {
            warn("No variants found for this product");
            return;
        }

        // Wait for MFGAD to have discount data for this product's variants
        waitForDiscounts(variantIds, () => {
            applyAll();
            wireReapply();
        });
    }

    if (document.readyState === "complete") init();
    else window.addEventListener("load", init);
})();
